<template>
	<el-dialog title="人工认证" center :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="400px">
		<p class="tips">人工审核的结果会被全局审核覆盖</p>
		<p class="tips">请确保全局审核后进行单独人工审核</p>
		<el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
			<el-form-item label="技能等级" prop="levelId">
				<el-select v-model="form.levelId" placeholder="请选择">
					<el-option v-for="item in signLevelList" :key="item.value" :label="item.levelName" :value="item.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="发证日期" prop="issueDate">
				<el-date-picker
					v-model="form.issueDate"
					type="date"
					value-format="yyyy-MM-dd"
					placeholder="请选择发证日期"></el-date-picker>
			</el-form-item>

		</el-form>
		<!-- 弹窗底部按钮 -->
		<span slot="footer" class="dialog-footer">
			<el-button @click="handleClose" :disabled="submitLoading">取消</el-button>
			<el-button type="primary" @click="handleSubmit" :loading="submitLoading">认证</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { debounce } from "@/utils/debounce";
import { courseSkillLevelList, courseSkillLockManual } from "@/api/skill";
export default {
	data() {
		return {
			dialogVisible: false, // 弹窗显示状态
			signLevelList: [], // 签约级别列表
			submitLoading: false, // 提交按钮loading，防止重复提交
			skillId: "",
			form: {
				lockId: "", // 锁定id
				levelId: [], //等级id
				issueDate: "", // 发证日期
			},
			// 表单验证规则
			rules: {
				levelId: [{ required: true, message: "请选择技能等级", trigger: "change" }],
				issueDate: [{ required: true, message: "请选择发证日期", trigger: "change" }],
			},
		};
	},

	methods: {
		init(row) {
			this.dialogVisible = true;
			// 等待DOM更新后重置表单
			this.$nextTick(() => {
				this.$refs.form.resetFields();
				// 设置skillId
				this.skillId = row.skillId;
				this.form.lockId = row.id;
				this.form.levelId = row.levelId;
				// 加载签约级别
				this.getSignLevel();
			});
		},

		/**
		 * 关闭弹窗
		 */
		handleClose() {
			this.dialogVisible = false;
			this.submitLoading = false;
		},

		/**
		 * 获取签约级别列表
		 * 从字典数据中获取contractLevel类型的选项
		 */
		getSignLevel() {
			courseSkillLevelList({ skillId: this.skillId }).then((res) => {
				const dataList = res.data || [];
				// 在列表开头插入默认选项
				this.signLevelList = [{ id: -1, levelName: '无' }, ...dataList];
			});
		},

		/**
		 * 提交表单
		 * 使用debounce防抖，防止重复提交
		 */
			handleSubmit: debounce(function () {
			if (this.submitLoading) return;
			// 表单验证
			this.$refs.form.validate((valid) => {
				if (!valid) return;

				// 开启提交loading
				this.submitLoading = true;
				courseSkillLockManual(this.form, true)
					.then((res) => {
						if (res.code === "0") {
							this.$message.success("认证成功");
							this.$emit("refresh");
							this.handleClose();
						} else {
							this.$message.error(res.msg || "认证失败");
						}
					})
					.finally(() => {
						this.submitLoading = false;
					});
			});
		}, 300),
	},
};
</script>

<style lang="scss" scoped>
.tips {
	color: red;
	margin-bottom: 5px;
	font-size: 12px;
}
.el-form {
	margin-top: 15px;
}

.el-select,
.el-date-picker {
	width: 220px;
}
</style>
